<template>

    <v-container fluid :key="mk_key">

        <v-row v-if="card_data && $route.query.setting_id" cols="12" sm="12" md="12" lg="12" class="pb-0 mb-3">
          <v-col cols="12" class="pb-0">
            <v-card
              class="mt-0 pt-2 pb-0 pl-0"
              :class="{
                'draft': card_data.status ==='draft',
                'release': card_data.status ==='running',
                'end': card_data.status ==='disable',
              }"
            >
              <v-card-title class="pl-3 pt-0 pb-2 text-subtile2 white--text d-flex justify-space-between align-center">
                <template v-if="card_data.status === 'draft'">
                  <p class="ma-0">
                    <v-icon color="white" class="mr-3">mdi-timer-outline</v-icon>
                    未發布(不會顯示)
                  </p>
                  <v-btn class="draft--text" color="white" @click="releaseMarketingCard">
                    <v-icon left color="draft">mdi-play-circle-outline</v-icon>
                    發布圖卡
                  </v-btn>
                </template>

                <template v-if="card_data.status === 'running'">
                  <p class="ma-0">
                    <v-icon color="white" class="mr-3">mdi-timer-outline</v-icon>
                    <span v-if="card_data.repeat_day === 0">發布中(顯示)</span>
                    <span v-else>循環中(顯示)</span>
                  </p>
                  <v-btn class="release--text" color="white" @click="stopMarketingCard">
                    <v-icon left color="release">
                      mdi-stop-circle-outline
                    </v-icon>
                    停止發布
                  </v-btn>
                </template>

                <template v-else-if="card_data.status === 'disable'">
                  <p class="ma-0">
                    <v-icon color="white" class="mr-3">mdi-check-circle-outline</v-icon>
                    已結束
                  </p>
                  <v-btn class="end--text" color="white" @click="stopMarketingCard">
                    <v-icon left color="end">mdi-chevron-left</v-icon>
                    返回草稿
                  </v-btn>
                </template>
              </v-card-title>
              <v-card-text
                class="pt-1 pb-1 pl-4 pr-0 text-subtitle-1 d-flex white--text"
                :class="{
                  'orange darken-2': card_data.status ==='draft',
                  'green darken-2': card_data.status ==='running',
                  'grey darken-2': card_data.status ==='disable',
                }"
              >
                <v-row>
                <v-col cols="12" xs="12" md="6" lg="6">
                  <p class="pb-0 mb-0 ">{{`開始: ${ $utils.displayISOString(card_data.start_at)}`}}</p>
                </v-col>
                <v-col cols="12" xs="12" md="6" lg="6">
                  <p class="pb-0 mb-0">{{`結束: ${$utils.displayISOString(card_data.end_at)}`}}</p>
                </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row cols="12" sm="8" md="6" lg="4" class="d-flex flex-nowrap flex-row-reverse">

            <v-col
                cols="5"
                style="position: sticky; top: 70px; overflow-y: auto; height: 800px;"
            >
                    <!-- <p style="font-weight: 700;" v-show="step!==1">
                        時間區間對照圖
                    </p> -->

                    <!-- <div id="time-line" style="margin: 20px;">

                        <TimeLineAboutUtils
                            :value="timeLine"
                            :align="`top`"
                            :layout="`horizontal`"
                            :oneTimeLine="displaySameTimeLineHint"
                            v-show="step!==1"
                        >
                            <template #opposite="slotProps">
                                <small
                                    class="p-text-secondary"
                                    :style="{
                                        maxWidth: '81px',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        display: 'block !important',
                                        
                                    }" 
                                >
                                    {{ slotProps.item.date }}
                                </small>
                            </template>
                            
                            <template #content="slotProps">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span
                                            class="truncate"
                                            v-bind='attrs'
                                            v-on='on'
                                            :style="{
                                                position: 'relative',
                                                top: '10px',
                                                left: '10px',
                                                color: slotProps.item.color,
                                            }"
                                        >
                                            {{ slotProps.item.time_line_mode }}
                                        </span>
                                    </template>    
                                    <span>{{ slotProps.item.time_line_mode }}</span>
                                </v-tooltip>    
                            </template>
                            
                        </TimeLineAboutUtils>
                    </div> -->

                    <!---  ---> 
                    <!-- <h2 class="mb-2 mt-2 ml-2">
                        <span style="color: red;">
                            {{ `${marketingCardMode}` }}
                        </span>
                        {{ `顯示圖卡` }}
                    </h2> -->

                    <OriginalCard
                        @card-innerhtml="updateCardInnerHTML"
                        :timeLineMode="newTimeLineMode"
                        :loadOldSettingData="isLoadOldSettingData"
                    />

                    <MiniCard
                        @mini-card-innerhtml="updateMiniCardInnerHTML"
                        @desktop-mini-card-innerhtml="updateDesktopMiniCardInnerHTML"
                        :timeLineMode="newTimeLineMode"
                        :loadOldSettingData="isLoadOldSettingData"
                    />
                    <MarketingCardProductInfo
                        v-if="card_data"
                        :card_data="card_data"
                        :loadOldSettingData="isLoadOldSettingData"
                        :timeLineMode="newTimeLineMode"
                    />

            </v-col>

            <v-col
                cols="7"
            >

                <v-card
                    :class="`${
                        step !== 1 ? 'step-other-style-card-action' : 'step-1-style-card-action' 
                    }`"
                >
                    <v-card-actions
                        class="d-flex pa-4"
                    >

                        <v-btn
                            @click="$router.go(-1)"
                            id="goBack"
                            color="primary"
                            class="white--text"
                        >
                            回上一頁
                        </v-btn>

                        <v-spacer></v-spacer>

                        <v-btn
                            v-if="this.$route.query.setting_id"
                            id="del"
                            @click="delSetting"
                            color="error"
                            class="white--text mr-6"  
                        >
                            刪除
                        </v-btn>

                        <v-btn
                            id="save"
                            @click="save"
                            color="primary"
                            class="white--text"   
                        >
                            保存    
                        </v-btn>

                    </v-card-actions>

                </v-card>
                <!--- tab會頻繁出現和消失，考量效能使用v-show --->
                <!-- <v-card
                    v-show="step!==1"
                    :style="{
                        position: `${step !== 1 ? 'sticky' : 'fixed'}`,
                        top: `${step !== 1 ? '65px' : '-70px'}`,
                        zIndex: `${step !== 1 && '5'}`
                    }"
                >
                    <v-tabs
                        fixed-tabs
                        v-model="selected_tab"
                        :color="this.$vuetify.theme.themes['dark']['primary']"
                        class="campaign-tab"
                    >
                        <v-tab
                            v-for="(item,index) in ['活動預熱','活動進行','活動結束']"
                            :key="item"
                            :value="index"
                            :disabled="disabledTab(index)"
                        >      
                            {{ item }}
                        </v-tab>
                    </v-tabs>
                </v-card> -->

                <v-stepper
                    non-linear
                    :value="whichStep"
                    color="primary"
                    :class="`${step !== 1 ? 'step-other-style-stepper' : 'step-1-style-stepper'}`"
                >
                    <v-stepper-header>

                        <v-stepper-step
                            step="1"
                            color="primary"
                            @click="$utils.scroll_to('basic-setting')"
                            style="cursor: pointer;"
                        >
                            基本設定
                        </v-stepper-step>

                        <v-divider></v-divider>

                        <v-stepper-step
                            step="2"
                            color="primary"
                            @click="$utils.scroll_to('normal-setting')"
                            style="cursor: pointer"
                        >
                            圖卡設定
                        </v-stepper-step>

                        <v-divider></v-divider>

                        <v-stepper-step
                            step="3"
                            color="primary"
                            style="cursor: pointer"
                            @click="$utils.scroll_to('advanced-setting')"
                        >
                            進階設定
                        </v-stepper-step>

                        <!-- <v-divider></v-divider> -->

                        <!-- <v-stepper-step
                            step="4"
                            :color="$vuetify.theme.themes['dark']['primary']"
                            style="cursor: pointer"
                            @click="$utils.scroll_to('advanced-setting')"
                        >
                            保存設定檔
                        </v-stepper-step> -->

                    </v-stepper-header>

                </v-stepper>

                <v-card
                    v-show=" step !== 1 "
                    :style="{
                        position: `${step !== 1 ? 'sticky' : 'fixed'}`,
                        top: `${step !== 1 ? '207px' : '-70px'}`,
                        zIndex: `${step !== 1 && '5'}`,
                        width: `${'50%'}`,
                        margin: 'auto'
                    }"
                >
                    <v-tabs
                        v-show="false"
                        fixed-tabs
                        v-model="selected_tab"
                        color="primary"
                        class="campaign-tab"
                    >
                        <template v-for="(item,index) in tabItems">
                            <v-tab
                                v-show="index === 1"
                                :key="item"
                                :value="index"
                                :disabled="disabledTab(index)"
                            >      
                                {{ item }}
                            </v-tab>
                        </template>

                    </v-tabs>
                </v-card>

                <MarketingCardSetting
                    v-if="is_loaded"
                    :card_data="card_data"
                    :cardInnerHTML="cardInnerHTML"
                    :miniCardInnerhtml="miniCardInnerHTML"
                    :desktopMiniCardInnerHTML="desktopMiniCardInnerHTML"
                    :modeCardSetting="modeCardSetting"
                    :oldTimeLineMode="oldTimeLineMode"
                    :newTimeLineMode="newTimeLineMode"
                    :saveMarketingCardSetting="saveMarketingCard"
                    :currentTimeLineMode="marketingCardMode"
                    @load-old-setting-data="loadOldSettingData(arguments)"
                    @marketing-card-mode="getMarketingCardMode(arguments)"
                    @get-mode-card-setting="getModeCardSetting(arguments)"
                    @get-time-line-mode="getTimeLineMode(arguments)"
                    @get-step="getStep(arguments)"
                    @get-time-line="getTimeLine(arguments)"
                    @same-time-line-hint="sameTimeLineHint(arguments)"
                    @reload="reload"
                />

            </v-col>

        </v-row>

        <transition name="fade" mode="out-in">
            <v-btn
                v-if="display"
                color="blue darken-2"
                dark
                fab
                style="position: fixed; bottom: 20px; right: 20px;"
                @click="goToTop"
            >
                <v-icon>
                    mdi-arrow-up
                </v-icon>
            </v-btn>
        </transition>

    </v-container>


</template>

<script>
import {
    apiGetCard,
    apiDeleteCardWithData,
    apiReleaseCard,
    apiDisabledCard
} from "@/api/sales-card.js";

// import 子元件
import OriginalCard from "./MarketingCardEditor/OriginalCard.vue";
import MiniCard from "./MarketingCardEditor/MiniCard.vue";
import MarketingCardProductInfo from "./MarketingCardEditor/MarketingCardProductInfo.vue";
import MarketingCardSetting from "./MarketingCardEditor/MarketingCardSetting.vue";
// import LoadingOverlay from "@/components/Utils/LoadingOverlay.vue";


// import TimeLineAboutUtils from "@/components/Utils/TimeLine.vue";


import { mapGetters } from 'vuex';

import goTo from 'vuetify/lib/services/goto'


export default {
    // directives: {
    //     'tooltip': Tooltip
    // },
    name: 'MarketingCardEdit',
    components: {
        OriginalCard,
        MiniCard,
        MarketingCardProductInfo,
        MarketingCardSetting,
        // Timeline,
        // TimeLineAboutUtils
        // Card,
        // Button
        // LoadingOverlay
    },
    data() {
        return {
            mode: 'all',
            timeLineTabs: [
                {
                    title: '活動預熱',
                    visible: true
                },
                {
                    title: '活動進行',
                    visible: true
                },
                {
                    title: '活動結束',
                    visible: true
                }
            ],
            saveMarketingCard: false,
            direction: 'top',
            display: false,
            fling: false,
            hover: true,
            tabs: null,
            top: false,
            right: true,
            bottom: true,
            left: false,
            transition: 'slide-y-reverse-transition',

            years: ['2019','2020','2021','2022'],

            // marketingCard: this.marketing_card ? this.marketing_card : null,

            timeLine: [
                {   
                    key: 'start_at',
                    status: '圖卡開始顯示時間',
                    date: "",
                    icon: 'pi pi-shopping-cart',
                    color: '#dee2e6',
                    time_line_mode: '活動預熱',
                    visible: true
                },
                {   
                    key: 'campaign_start_at',
                    status: '活動開始時間',
                    date: "",
                    icon: 'pi pi-cog',
                    color: '#dee2e6',
                    time_line_mode: '活動進行',
                    visible: true
                },
                {   
                    key: 'campaign_end_at',
                    status: '活動結束時間',
                    date: "",
                    icon: 'pi pi-shopping-cart',
                    color: '#dee2e6',
                    time_line_mode: '活動結束',
                    visible: true
                },
                {   
                    key: 'end_at',
                    status: '圖卡結束顯示時間',
                    date: "",
                    icon: 'pi pi-check',
                    color: '#dee2e6',
                    visible: true
                }
            ],

            newTimeLineList: [
                {   
                    key: 'start_at',
                    status: '圖卡開始顯示時間',
                    date: "",
                    icon: 'pi pi-shopping-cart',
                    color: '#dee2e6',
                    time_line_mode: '活動進行',
                    visible: true,
                    left: '100px;',
                    sameTimeColor: 'red'
                },
                {   
                    key: 'campaign_start_at',
                    status: '活動開始時間',
                    date: "",
                    icon: 'pi pi-cog',
                    color: '#dee2e6',
                    time_line_mode: '',
                    visible: true
                }
            ],

            selected_tab: 1,

            /* 是否自動帶入優惠代碼 */
      	    // isAutoCoupon: false,
            cardInnerHTML: '',
            miniCardInnerHTML: '',
            desktopMiniCardInnerHTML: '',
            isLoadOldSettingData: false,
            marketingCardMode: '活動預熱',

            // 各區間暫存設定檔
            marketingCardModeSetting: {
                '活動預熱': {
                    card_setting: {
                        "is_countdown": false,
                        "tags": "",
                        "setting_name": "",
                        "card_content": "<div data-v-3fb63380=\"\" class=\"card\" style=\"overflow: hidden; display: flex; flex-direction: column; width: 100%; min-width: 340px; box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\"><article data-v-7f17b75b=\"\" data-v-3fb63380=\"\" class=\"count-down-timer\" style=\"\"><div data-v-7f17b75b=\"\" class=\"time_container\" style=\"text-align: center; background-color: rgb(255, 179, 190); padding-top: 3px; padding-bottom: 3px; display: flex; justify-content: center; align-items: center; font-weight: bold; font-size: 18px;\"><section data-v-7f17b75b=\"\" class=\"t_description\" style=\"margin-right: 0.3em; color: rgb(255, 15, 15);\"> 限時倒數 </section><section data-v-7f17b75b=\"\" class=\"t_days\" style=\"text-align: center; min-width: 24px; color: rgb(255, 255, 255);\">00</section><section data-v-7f17b75b=\"\" class=\"t_days_unit\" style=\"color: rgb(255, 255, 255);\"> 日 </section><section data-v-7f17b75b=\"\" class=\"t_hours\" style=\"text-align: center; width: 24px; color: rgb(255, 255, 255);\">00</section><section data-v-7f17b75b=\"\" class=\"t_hours_unit\" style=\"margin-right: 0.3em; color: rgb(255, 255, 255);\"> 小時 </section><section data-v-7f17b75b=\"\" class=\"t_minutes\" style=\"text-align: center; width: 23px; color: rgb(255, 255, 255);\">00</section><section data-v-7f17b75b=\"\" class=\"t_minutes_unit\" style=\"margin-right: 0.3em; color: rgb(255, 255, 255);\"> 分 </section><section data-v-7f17b75b=\"\" class=\"t_seconds\" style=\"text-align: center; width: 24px; color: rgb(255, 255, 255);\">00</section><section data-v-7f17b75b=\"\" class=\"t_seconds_unit\" style=\"color: rgb(255, 255, 255);\"> 秒 </section><section data-v-7f17b75b=\"\" class=\"t_description_end\" style=\"margin-left: 0.3em; color: rgb(255, 15, 15);\"> ！ </section></div><div data-v-7f17b75b=\"\" class=\"time_off_text\" style=\"text-align: center; background-color: rgb(255, 179, 190); padding-top: 3px; padding-bottom: 3px; display: none; justify-content: center; align-items: center; font-weight: bold; font-size: 18px;\"><section data-v-7f17b75b=\"\" class=\"t_off_text\" style=\"margin-right: 0.3em; color: rgb(255, 15, 15);\"> 活動已結束 </section></div></article><article data-v-3fb63380=\"\" class=\"card-content\" style=\"display: flex; flex-direction: row; overflow: hidden; max-height: 100px;\"><img data-v-3fb63380=\"\" src=\"https://pic.optimize99.com/api/img/_/cmp/1690251392463.jpg\" class=\"card-img\" style=\"min-width: 100px; max-width: 100px; width: 100px; height: 100px; min-height: 100px; max-height: 100px;\"><section data-v-3fb63380=\"\" class=\"card-text\" style=\"width: 100%;\"><div data-v-3fb63380=\"\" class=\"card-header\" style=\"min-height: 1em; background-color: rgb(255, 255, 255); color: rgb(0, 0, 0); position: relative;\"><h3 data-v-3fb63380=\"\" style=\"text-align: left; padding: 3px 15px 3px 12px; font-size: 20px; margin: 0px; font-weight: bold; line-height: normal;\"> 圖卡標題 </h3><i data-v-3fb63380=\"\" name=\"close_card_btn\" style=\"position: absolute; color: rgb(0, 0, 0); font-style: normal; right: 12px; top: 4px; cursor: pointer;\"> ✕ </i></div><section data-v-3fb63380=\"\" class=\"card-text-content\" style=\"padding-left: 12px; height: 100%; background-color: rgb(255, 255, 255); font-size: 16px;\"><p>圖卡內文</p></section></section></article><article data-v-3fb63380=\"\" class=\"card-footer\" style=\"min-height: 1em; background-color: rgb(255, 255, 255);\"><h3 data-v-3fb63380=\"\" style=\"text-align: center; margin: 0px; font-size: 18px; font-weight: bold; letter-spacing: 3px; color: rgb(0, 0, 0); padding: 5px; line-height: normal;\"> 行銷文字 </h3></article></div>",
                        // "card_content": "",
                        "coupon_id": "",
                        "preview_url": "",
                        "start_at": "",
                        "campaign_start_at": "",
                        "end_at": "",
                        "campaign_end_at": "",
                        "repeat_day": 0,
                        "card_hint": "<div data-v-473f8646=\"\" class=\"mini-card\" style=\"width: 100%; min-height: 1em; background-color: rgb(255, 179, 190); color: rgb(255, 255, 255); text-align: center; cursor: pointer; padding: 5px 0px; font-weight: bold; font-size: 14px;\"><div data-v-473f8646=\"\" class=\"mini-card-text-container\"> 手機縮小的行銷文字 </div><article data-v-7f17b75b=\"\" data-v-473f8646=\"\" class=\"count-down-timer\" style=\"\"><div data-v-7f17b75b=\"\" class=\"time_container\" style=\"text-align: center; background-color: transparent; padding-top: 3px; padding-bottom: 3px; display: flex; justify-content: center; align-items: center; font-weight: bold; font-size: 14px;\"><section data-v-7f17b75b=\"\" class=\"t_description\" style=\"margin-right: 0.3em; color: rgb(0, 0, 0);\"> ▼ </section><section data-v-7f17b75b=\"\" class=\"t_days\" style=\"text-align: center; min-width: 24px; color: rgb(255, 255, 255);\">00</section><section data-v-7f17b75b=\"\" class=\"t_days_unit\" style=\"color: rgb(255, 255, 255);\"> 日 </section><section data-v-7f17b75b=\"\" class=\"t_hours\" style=\"text-align: center; width: 24px; color: rgb(255, 255, 255);\">00</section><section data-v-7f17b75b=\"\" class=\"t_hours_unit\" style=\"margin-right: 0.3em; color: rgb(255, 255, 255);\"> 小時 </section><section data-v-7f17b75b=\"\" class=\"t_minutes\" style=\"text-align: center; width: 23px; color: rgb(255, 255, 255);\">00</section><section data-v-7f17b75b=\"\" class=\"t_minutes_unit\" style=\"margin-right: 0.3em; color: rgb(255, 255, 255);\"> 分 </section><section data-v-7f17b75b=\"\" class=\"t_seconds\" style=\"text-align: center; width: 24px; color: rgb(255, 255, 255);\">00</section><section data-v-7f17b75b=\"\" class=\"t_seconds_unit\" style=\"color: rgb(255, 255, 255);\"> 秒 </section><section data-v-7f17b75b=\"\" class=\"t_description_end\" style=\"margin-left: 0.3em; color: rgb(0, 0, 0);\"> ▼ </section></div><div data-v-7f17b75b=\"\" class=\"time_off_text\" style=\"text-align: center; background-color: transparent; padding-top: 3px; padding-bottom: 3px; display: none; justify-content: center; align-items: center; font-weight: bold; font-size: 14px;\"><section data-v-7f17b75b=\"\" class=\"t_off_text\" style=\"margin-right: 0.3em; color: rgb(255, 15, 15);\"> 活動已結束 </section></div></article></div>",
                        "desktop_card_hint": "<div data-v-473f8646=\"\" class=\"mini-card\" style=\"width: 100%; min-height: 1em; background-color: rgb(255, 179, 190); color: rgb(255, 255, 255); text-align: center; cursor: pointer; padding: 5px 0px; font-weight: bold; font-size: 14px;\"><div data-v-473f8646=\"\" class=\"mini-card-text-container\"> 桌機縮小的行銷文字 </div><article data-v-7f17b75b=\"\" data-v-473f8646=\"\" class=\"count-down-timer\" style=\"\"><div data-v-7f17b75b=\"\" class=\"time_container\" style=\"text-align: center; background-color: transparent; padding-top: 3px; padding-bottom: 3px; display: flex; justify-content: center; align-items: center; font-weight: bold; font-size: 14px;\"><section data-v-7f17b75b=\"\" class=\"t_description\" style=\"margin-right: 0.3em; color: rgb(0, 0, 0);\"> ▶ </section><section data-v-7f17b75b=\"\" class=\"t_days\" style=\"text-align: center; min-width: 24px; color: rgb(255, 255, 255);\">00</section><section data-v-7f17b75b=\"\" class=\"t_days_unit\" style=\"color: rgb(255, 255, 255);\"> 日 </section><section data-v-7f17b75b=\"\" class=\"t_hours\" style=\"text-align: center; width: 24px; color: rgb(255, 255, 255);\">00</section><section data-v-7f17b75b=\"\" class=\"t_hours_unit\" style=\"margin-right: 0.3em; color: rgb(255, 255, 255);\"> 小時 </section><section data-v-7f17b75b=\"\" class=\"t_minutes\" style=\"text-align: center; width: 23px; color: rgb(255, 255, 255);\">00</section><section data-v-7f17b75b=\"\" class=\"t_minutes_unit\" style=\"margin-right: 0.3em; color: rgb(255, 255, 255);\"> 分 </section><section data-v-7f17b75b=\"\" class=\"t_seconds\" style=\"text-align: center; width: 24px; color: rgb(255, 255, 255);\">00</section><section data-v-7f17b75b=\"\" class=\"t_seconds_unit\" style=\"color: rgb(255, 255, 255);\"> 秒 </section><section data-v-7f17b75b=\"\" class=\"t_description_end\" style=\"margin-left: 0.3em; color: rgb(0, 0, 0);\"> ▶ </section></div><div data-v-7f17b75b=\"\" class=\"time_off_text\" style=\"text-align: center; background-color: transparent; padding-top: 3px; padding-bottom: 3px; display: none; justify-content: center; align-items: center; font-weight: bold; font-size: 14px;\"><section data-v-7f17b75b=\"\" class=\"t_off_text\" style=\"margin-right: 0.3em; color: rgb(255, 15, 15);\"> 活動已結束 </section></div></article></div>",
                        "mobile_card_margin": "50px 0px 0px 0px",
                        "mobile_card_padding": "0px 5px",
                        "mobile_mini_card_margin": "50px 0px 0px 0px",
                        "mobile_mini_card_padding": "0px 0px 0px 0px",
                        "desktop_card_margin": "0px 10px 10px 0px",
                        "container_id": "",
                        "add_column": "{\"product_mode\":0,\"timer_off_text\":\"活動已結束\",\"timer_off_text_color\":\"#ff0f0f\",\"discount_price\":\"NT$\",\"discount_price_size\":\"\",\"discount_price_color\":\"#ff0f0f\",\"product_text\":\"\",\"product_text_color\":\"#ff0f0f\",\"product_text_size\":\"\"}"
                    }
                },
                '活動進行': {
                    card_setting: {
                        "is_countdown": false,
                        "tags": "",
                        "setting_name": "",
                        "card_content": "<div data-v-3fb63380=\"\" class=\"card\" style=\"overflow: hidden; display: flex; flex-direction: column; width: 100%; min-width: 340px; box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\"><article data-v-7f17b75b=\"\" data-v-3fb63380=\"\" class=\"count-down-timer\" style=\"\"><div data-v-7f17b75b=\"\" class=\"time_container\" style=\"text-align: center; background-color: rgb(255, 179, 190); padding-top: 3px; padding-bottom: 3px; display: flex; justify-content: center; align-items: center; font-weight: bold; font-size: 18px;\"><section data-v-7f17b75b=\"\" class=\"t_description\" style=\"margin-right: 0.3em; color: rgb(255, 15, 15);\"> 限時倒數 </section><section data-v-7f17b75b=\"\" class=\"t_days\" style=\"text-align: center; min-width: 24px; color: rgb(255, 255, 255);\">00</section><section data-v-7f17b75b=\"\" class=\"t_days_unit\" style=\"color: rgb(255, 255, 255);\"> 日 </section><section data-v-7f17b75b=\"\" class=\"t_hours\" style=\"text-align: center; width: 24px; color: rgb(255, 255, 255);\">00</section><section data-v-7f17b75b=\"\" class=\"t_hours_unit\" style=\"margin-right: 0.3em; color: rgb(255, 255, 255);\"> 小時 </section><section data-v-7f17b75b=\"\" class=\"t_minutes\" style=\"text-align: center; width: 23px; color: rgb(255, 255, 255);\">00</section><section data-v-7f17b75b=\"\" class=\"t_minutes_unit\" style=\"margin-right: 0.3em; color: rgb(255, 255, 255);\"> 分 </section><section data-v-7f17b75b=\"\" class=\"t_seconds\" style=\"text-align: center; width: 24px; color: rgb(255, 255, 255);\">00</section><section data-v-7f17b75b=\"\" class=\"t_seconds_unit\" style=\"color: rgb(255, 255, 255);\"> 秒 </section><section data-v-7f17b75b=\"\" class=\"t_description_end\" style=\"margin-left: 0.3em; color: rgb(255, 15, 15);\"> ！ </section></div><div data-v-7f17b75b=\"\" class=\"time_off_text\" style=\"text-align: center; background-color: rgb(255, 179, 190); padding-top: 3px; padding-bottom: 3px; display: none; justify-content: center; align-items: center; font-weight: bold; font-size: 18px;\"><section data-v-7f17b75b=\"\" class=\"t_off_text\" style=\"margin-right: 0.3em; color: rgb(255, 15, 15);\"> 活動已結束 </section></div></article><article data-v-3fb63380=\"\" class=\"card-content\" style=\"display: flex; flex-direction: row; overflow: hidden; max-height: 100px;\"><img data-v-3fb63380=\"\" src=\"https://pic.optimize99.com/api/img/_/cmp/1690251392463.jpg\" class=\"card-img\" style=\"min-width: 100px; max-width: 100px; width: 100px; height: 100px; min-height: 100px; max-height: 100px;\"><section data-v-3fb63380=\"\" class=\"card-text\" style=\"width: 100%;\"><div data-v-3fb63380=\"\" class=\"card-header\" style=\"min-height: 1em; background-color: rgb(255, 255, 255); color: rgb(0, 0, 0); position: relative;\"><h3 data-v-3fb63380=\"\" style=\"text-align: left; padding: 3px 15px 3px 12px; font-size: 20px; margin: 0px; font-weight: bold; line-height: normal;\"> 圖卡標題 </h3><i data-v-3fb63380=\"\" name=\"close_card_btn\" style=\"position: absolute; color: rgb(0, 0, 0); font-style: normal; right: 12px; top: 4px; cursor: pointer;\"> ✕ </i></div><section data-v-3fb63380=\"\" class=\"card-text-content\" style=\"padding-left: 12px; height: 100%; background-color: rgb(255, 255, 255); font-size: 16px;\"><p>圖卡內文</p></section></section></article><article data-v-3fb63380=\"\" class=\"card-footer\" style=\"min-height: 1em; background-color: rgb(255, 255, 255);\"><h3 data-v-3fb63380=\"\" style=\"text-align: center; margin: 0px; font-size: 18px; font-weight: bold; letter-spacing: 3px; color: rgb(0, 0, 0); padding: 5px; line-height: normal;\"> 行銷文字 </h3></article></div>",
                        "coupon_id": "",
                        "preview_url": "",
                        "start_at": "",
                        "campaign_start_at": "",
                        "end_at": "",
                        "campaign_end_at": "",
                        "repeat_day": 0,
                        "card_hint": "<div data-v-473f8646=\"\" class=\"mini-card\" style=\"width: 100%; min-height: 1em; background-color: rgb(255, 179, 190); color: rgb(255, 255, 255); text-align: center; cursor: pointer; padding: 5px 0px; font-weight: bold; font-size: 14px;\"><div data-v-473f8646=\"\" class=\"mini-card-text-container\"> 手機縮小的行銷文字 </div><article data-v-7f17b75b=\"\" data-v-473f8646=\"\" class=\"count-down-timer\" style=\"\"><div data-v-7f17b75b=\"\" class=\"time_container\" style=\"text-align: center; background-color: transparent; padding-top: 3px; padding-bottom: 3px; display: flex; justify-content: center; align-items: center; font-weight: bold; font-size: 14px;\"><section data-v-7f17b75b=\"\" class=\"t_description\" style=\"margin-right: 0.3em; color: rgb(0, 0, 0);\"> ▼ </section><section data-v-7f17b75b=\"\" class=\"t_days\" style=\"text-align: center; min-width: 24px; color: rgb(255, 255, 255);\">00</section><section data-v-7f17b75b=\"\" class=\"t_days_unit\" style=\"color: rgb(255, 255, 255);\"> 日 </section><section data-v-7f17b75b=\"\" class=\"t_hours\" style=\"text-align: center; width: 24px; color: rgb(255, 255, 255);\">00</section><section data-v-7f17b75b=\"\" class=\"t_hours_unit\" style=\"margin-right: 0.3em; color: rgb(255, 255, 255);\"> 小時 </section><section data-v-7f17b75b=\"\" class=\"t_minutes\" style=\"text-align: center; width: 23px; color: rgb(255, 255, 255);\">00</section><section data-v-7f17b75b=\"\" class=\"t_minutes_unit\" style=\"margin-right: 0.3em; color: rgb(255, 255, 255);\"> 分 </section><section data-v-7f17b75b=\"\" class=\"t_seconds\" style=\"text-align: center; width: 24px; color: rgb(255, 255, 255);\">00</section><section data-v-7f17b75b=\"\" class=\"t_seconds_unit\" style=\"color: rgb(255, 255, 255);\"> 秒 </section><section data-v-7f17b75b=\"\" class=\"t_description_end\" style=\"margin-left: 0.3em; color: rgb(0, 0, 0);\"> ▼ </section></div><div data-v-7f17b75b=\"\" class=\"time_off_text\" style=\"text-align: center; background-color: transparent; padding-top: 3px; padding-bottom: 3px; display: none; justify-content: center; align-items: center; font-weight: bold; font-size: 14px;\"><section data-v-7f17b75b=\"\" class=\"t_off_text\" style=\"margin-right: 0.3em; color: rgb(255, 15, 15);\"> 活動已結束 </section></div></article></div>",
                        "desktop_card_hint": "<div data-v-473f8646=\"\" class=\"mini-card\" style=\"width: 100%; min-height: 1em; background-color: rgb(255, 179, 190); color: rgb(255, 255, 255); text-align: center; cursor: pointer; padding: 5px 0px; font-weight: bold; font-size: 14px;\"><div data-v-473f8646=\"\" class=\"mini-card-text-container\"> 桌機縮小的行銷文字 </div><article data-v-7f17b75b=\"\" data-v-473f8646=\"\" class=\"count-down-timer\" style=\"\"><div data-v-7f17b75b=\"\" class=\"time_container\" style=\"text-align: center; background-color: transparent; padding-top: 3px; padding-bottom: 3px; display: flex; justify-content: center; align-items: center; font-weight: bold; font-size: 14px;\"><section data-v-7f17b75b=\"\" class=\"t_description\" style=\"margin-right: 0.3em; color: rgb(0, 0, 0);\"> ▶ </section><section data-v-7f17b75b=\"\" class=\"t_days\" style=\"text-align: center; min-width: 24px; color: rgb(255, 255, 255);\">00</section><section data-v-7f17b75b=\"\" class=\"t_days_unit\" style=\"color: rgb(255, 255, 255);\"> 日 </section><section data-v-7f17b75b=\"\" class=\"t_hours\" style=\"text-align: center; width: 24px; color: rgb(255, 255, 255);\">00</section><section data-v-7f17b75b=\"\" class=\"t_hours_unit\" style=\"margin-right: 0.3em; color: rgb(255, 255, 255);\"> 小時 </section><section data-v-7f17b75b=\"\" class=\"t_minutes\" style=\"text-align: center; width: 23px; color: rgb(255, 255, 255);\">00</section><section data-v-7f17b75b=\"\" class=\"t_minutes_unit\" style=\"margin-right: 0.3em; color: rgb(255, 255, 255);\"> 分 </section><section data-v-7f17b75b=\"\" class=\"t_seconds\" style=\"text-align: center; width: 24px; color: rgb(255, 255, 255);\">00</section><section data-v-7f17b75b=\"\" class=\"t_seconds_unit\" style=\"color: rgb(255, 255, 255);\"> 秒 </section><section data-v-7f17b75b=\"\" class=\"t_description_end\" style=\"margin-left: 0.3em; color: rgb(0, 0, 0);\"> ▶ </section></div><div data-v-7f17b75b=\"\" class=\"time_off_text\" style=\"text-align: center; background-color: transparent; padding-top: 3px; padding-bottom: 3px; display: none; justify-content: center; align-items: center; font-weight: bold; font-size: 14px;\"><section data-v-7f17b75b=\"\" class=\"t_off_text\" style=\"margin-right: 0.3em; color: rgb(255, 15, 15);\"> 活動已結束 </section></div></article></div>",
                        "mobile_card_margin": "50px 0px 0px 0px",
                        "mobile_card_padding": "0px 5px",
                        "mobile_mini_card_margin": "50px 0px 0px 0px",
                        "mobile_mini_card_padding": "0px 0px 0px 0px",
                        "desktop_card_margin": "0px 10px 10px 0px",
                        "container_id": "",
                        "add_column": "{\"product_mode\":0,\"timer_off_text\":\"活動已結束\",\"timer_off_text_color\":\"#ff0f0f\",\"discount_price\":\"NT$\",\"discount_price_size\":\"\",\"discount_price_color\":\"#ff0f0f\",\"product_text\":\"\",\"product_text_color\":\"#ff0f0f\",\"product_text_size\":\"\"}"
                    }
                },
                '活動結束': {
                    card_setting: {
                        "is_countdown": false,
                        "tags": "",
                        "setting_name": "",
                        "card_content": "<div data-v-3fb63380=\"\" class=\"card\" style=\"overflow: hidden; display: flex; flex-direction: column; width: 100%; min-width: 340px; box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\"><article data-v-7f17b75b=\"\" data-v-3fb63380=\"\" class=\"count-down-timer\" style=\"\"><div data-v-7f17b75b=\"\" class=\"time_container\" style=\"text-align: center; background-color: rgb(255, 179, 190); padding-top: 3px; padding-bottom: 3px; display: flex; justify-content: center; align-items: center; font-weight: bold; font-size: 18px;\"><section data-v-7f17b75b=\"\" class=\"t_description\" style=\"margin-right: 0.3em; color: rgb(255, 15, 15);\"> 限時倒數 </section><section data-v-7f17b75b=\"\" class=\"t_days\" style=\"text-align: center; min-width: 24px; color: rgb(255, 255, 255);\">00</section><section data-v-7f17b75b=\"\" class=\"t_days_unit\" style=\"color: rgb(255, 255, 255);\"> 日 </section><section data-v-7f17b75b=\"\" class=\"t_hours\" style=\"text-align: center; width: 24px; color: rgb(255, 255, 255);\">00</section><section data-v-7f17b75b=\"\" class=\"t_hours_unit\" style=\"margin-right: 0.3em; color: rgb(255, 255, 255);\"> 小時 </section><section data-v-7f17b75b=\"\" class=\"t_minutes\" style=\"text-align: center; width: 23px; color: rgb(255, 255, 255);\">00</section><section data-v-7f17b75b=\"\" class=\"t_minutes_unit\" style=\"margin-right: 0.3em; color: rgb(255, 255, 255);\"> 分 </section><section data-v-7f17b75b=\"\" class=\"t_seconds\" style=\"text-align: center; width: 24px; color: rgb(255, 255, 255);\">00</section><section data-v-7f17b75b=\"\" class=\"t_seconds_unit\" style=\"color: rgb(255, 255, 255);\"> 秒 </section><section data-v-7f17b75b=\"\" class=\"t_description_end\" style=\"margin-left: 0.3em; color: rgb(255, 15, 15);\"> ！ </section></div><div data-v-7f17b75b=\"\" class=\"time_off_text\" style=\"text-align: center; background-color: rgb(255, 179, 190); padding-top: 3px; padding-bottom: 3px; display: none; justify-content: center; align-items: center; font-weight: bold; font-size: 18px;\"><section data-v-7f17b75b=\"\" class=\"t_off_text\" style=\"margin-right: 0.3em; color: rgb(255, 15, 15);\"> 活動已結束 </section></div></article><article data-v-3fb63380=\"\" class=\"card-content\" style=\"display: flex; flex-direction: row; overflow: hidden; max-height: 100px;\"><img data-v-3fb63380=\"\" src=\"https://pic.optimize99.com/api/img/_/cmp/1690251392463.jpg\" class=\"card-img\" style=\"min-width: 100px; max-width: 100px; width: 100px; height: 100px; min-height: 100px; max-height: 100px;\"><section data-v-3fb63380=\"\" class=\"card-text\" style=\"width: 100%;\"><div data-v-3fb63380=\"\" class=\"card-header\" style=\"min-height: 1em; background-color: rgb(255, 255, 255); color: rgb(0, 0, 0); position: relative;\"><h3 data-v-3fb63380=\"\" style=\"text-align: left; padding: 3px 15px 3px 12px; font-size: 20px; margin: 0px; font-weight: bold; line-height: normal;\"> 圖卡標題 </h3><i data-v-3fb63380=\"\" name=\"close_card_btn\" style=\"position: absolute; color: rgb(0, 0, 0); font-style: normal; right: 12px; top: 4px; cursor: pointer;\"> ✕ </i></div><section data-v-3fb63380=\"\" class=\"card-text-content\" style=\"padding-left: 12px; height: 100%; background-color: rgb(255, 255, 255); font-size: 16px;\"><p>圖卡內文</p></section></section></article><article data-v-3fb63380=\"\" class=\"card-footer\" style=\"min-height: 1em; background-color: rgb(255, 255, 255);\"><h3 data-v-3fb63380=\"\" style=\"text-align: center; margin: 0px; font-size: 18px; font-weight: bold; letter-spacing: 3px; color: rgb(0, 0, 0); padding: 5px; line-height: normal;\"> 行銷文字 </h3></article></div>",
                        "coupon_id": "",
                        "preview_url": "",
                        "start_at": "",
                        "campaign_start_at": "",
                        "end_at": "",
                        "campaign_end_at": "",
                        "repeat_day": 0,
                        "card_hint": "<div data-v-473f8646=\"\" class=\"mini-card\" style=\"width: 100%; min-height: 1em; background-color: rgb(255, 179, 190); color: rgb(255, 255, 255); text-align: center; cursor: pointer; padding: 5px 0px; font-weight: bold; font-size: 14px;\"><div data-v-473f8646=\"\" class=\"mini-card-text-container\"> 手機縮小的行銷文字 </div><article data-v-7f17b75b=\"\" data-v-473f8646=\"\" class=\"count-down-timer\" style=\"\"><div data-v-7f17b75b=\"\" class=\"time_container\" style=\"text-align: center; background-color: transparent; padding-top: 3px; padding-bottom: 3px; display: flex; justify-content: center; align-items: center; font-weight: bold; font-size: 14px;\"><section data-v-7f17b75b=\"\" class=\"t_description\" style=\"margin-right: 0.3em; color: rgb(0, 0, 0);\"> ▼ </section><section data-v-7f17b75b=\"\" class=\"t_days\" style=\"text-align: center; min-width: 24px; color: rgb(255, 255, 255);\">00</section><section data-v-7f17b75b=\"\" class=\"t_days_unit\" style=\"color: rgb(255, 255, 255);\"> 日 </section><section data-v-7f17b75b=\"\" class=\"t_hours\" style=\"text-align: center; width: 24px; color: rgb(255, 255, 255);\">00</section><section data-v-7f17b75b=\"\" class=\"t_hours_unit\" style=\"margin-right: 0.3em; color: rgb(255, 255, 255);\"> 小時 </section><section data-v-7f17b75b=\"\" class=\"t_minutes\" style=\"text-align: center; width: 23px; color: rgb(255, 255, 255);\">00</section><section data-v-7f17b75b=\"\" class=\"t_minutes_unit\" style=\"margin-right: 0.3em; color: rgb(255, 255, 255);\"> 分 </section><section data-v-7f17b75b=\"\" class=\"t_seconds\" style=\"text-align: center; width: 24px; color: rgb(255, 255, 255);\">00</section><section data-v-7f17b75b=\"\" class=\"t_seconds_unit\" style=\"color: rgb(255, 255, 255);\"> 秒 </section><section data-v-7f17b75b=\"\" class=\"t_description_end\" style=\"margin-left: 0.3em; color: rgb(0, 0, 0);\"> ▼ </section></div><div data-v-7f17b75b=\"\" class=\"time_off_text\" style=\"text-align: center; background-color: transparent; padding-top: 3px; padding-bottom: 3px; display: none; justify-content: center; align-items: center; font-weight: bold; font-size: 14px;\"><section data-v-7f17b75b=\"\" class=\"t_off_text\" style=\"margin-right: 0.3em; color: rgb(255, 15, 15);\"> 活動已結束 </section></div></article></div>",
                        "desktop_card_hint": "<div data-v-473f8646=\"\" class=\"mini-card\" style=\"width: 100%; min-height: 1em; background-color: rgb(255, 179, 190); color: rgb(255, 255, 255); text-align: center; cursor: pointer; padding: 5px 0px; font-weight: bold; font-size: 14px;\"><div data-v-473f8646=\"\" class=\"mini-card-text-container\"> 桌機縮小的行銷文字 </div><article data-v-7f17b75b=\"\" data-v-473f8646=\"\" class=\"count-down-timer\" style=\"\"><div data-v-7f17b75b=\"\" class=\"time_container\" style=\"text-align: center; background-color: transparent; padding-top: 3px; padding-bottom: 3px; display: flex; justify-content: center; align-items: center; font-weight: bold; font-size: 14px;\"><section data-v-7f17b75b=\"\" class=\"t_description\" style=\"margin-right: 0.3em; color: rgb(0, 0, 0);\"> ▶ </section><section data-v-7f17b75b=\"\" class=\"t_days\" style=\"text-align: center; min-width: 24px; color: rgb(255, 255, 255);\">00</section><section data-v-7f17b75b=\"\" class=\"t_days_unit\" style=\"color: rgb(255, 255, 255);\"> 日 </section><section data-v-7f17b75b=\"\" class=\"t_hours\" style=\"text-align: center; width: 24px; color: rgb(255, 255, 255);\">00</section><section data-v-7f17b75b=\"\" class=\"t_hours_unit\" style=\"margin-right: 0.3em; color: rgb(255, 255, 255);\"> 小時 </section><section data-v-7f17b75b=\"\" class=\"t_minutes\" style=\"text-align: center; width: 23px; color: rgb(255, 255, 255);\">00</section><section data-v-7f17b75b=\"\" class=\"t_minutes_unit\" style=\"margin-right: 0.3em; color: rgb(255, 255, 255);\"> 分 </section><section data-v-7f17b75b=\"\" class=\"t_seconds\" style=\"text-align: center; width: 24px; color: rgb(255, 255, 255);\">00</section><section data-v-7f17b75b=\"\" class=\"t_seconds_unit\" style=\"color: rgb(255, 255, 255);\"> 秒 </section><section data-v-7f17b75b=\"\" class=\"t_description_end\" style=\"margin-left: 0.3em; color: rgb(0, 0, 0);\"> ▶ </section></div><div data-v-7f17b75b=\"\" class=\"time_off_text\" style=\"text-align: center; background-color: transparent; padding-top: 3px; padding-bottom: 3px; display: none; justify-content: center; align-items: center; font-weight: bold; font-size: 14px;\"><section data-v-7f17b75b=\"\" class=\"t_off_text\" style=\"margin-right: 0.3em; color: rgb(255, 15, 15);\"> 活動已結束 </section></div></article></div>",
                        "mobile_card_margin": "50px 0px 0px 0px",
                        "mobile_card_padding": "0px 5px",
                        "mobile_mini_card_margin": "50px 0px 0px 0px",
                        "mobile_mini_card_padding": "0px 0px 0px 0px",
                        "desktop_card_margin": "0px 10px 10px 0px",
                        "container_id": "",
                        "add_column": "{\"product_mode\":0,\"timer_off_text\":\"活動已結束\",\"timer_off_text_color\":\"#ff0f0f\",\"discount_price\":\"NT$\",\"discount_price_size\":\"\",\"discount_price_color\":\"#ff0f0f\",\"product_text\":\"\",\"product_text_color\":\"#ff0f0f\",\"product_text_size\":\"\"}"
                    }
                }
            },
            modeCardSetting: null,
            time_line_mode: '',
            step: 1,
            // isLoading: false

            tab_index_mapper: {
                0 : "活動預熱",
                1 : "活動進行",
                2 : "活動結束"
            },

            oldTimeLineMode: "活動進行",
            newTimeLineMode: "活動進行",
            displaySameTimeLineHint: false,
            SameTimeLineHintMsg: '',
            scrollHandler: null,
            card_data: null ,
            is_loaded: false,
            mk_key: 1,
        }
    },
    async created() {
        await this.reload()
    },
    watch: {
        top (val) {
            this.bottom = !val
        },
        right (val) {
            this.left = !val
        },
        bottom (val) {
            this.top = !val
        },
        left (val) {
            this.right = !val
        },
        marketingCardMode: {
            handler: function(newVal, oldVal) {
                console.log("oldVal", oldVal)
                console.log("newVal", newVal)
            }
        },
        selected_tab: {
            handler: async function(newVal, oldVal) {
                console.log("oldVal", oldVal)
                console.log("newVal", newVal)
                oldVal !== undefined ? this.timeLine[oldVal]['color'] = '#dee2e6' : oldVal
                newVal !== undefined ? this.timeLine[newVal]['color'] = 'red' : newVal
                
                // 統一在這把html塞進marketing_card，其他地方不要寫這個會有side effect，如果在其他地方才寫這個會把新的區間資料存到舊的區間去，導致一堆bug
                await this.changeStatus('marketing_card','get_ele_innerHTML', true)
                
                console.log("舊的區間：", this.tab_index_mapper[oldVal])
                console.log("新的區間：", this.tab_index_mapper[newVal])
                console.log("舊的", this.tab_index_mapper[oldVal]);
                console.log("新的", this.tab_index_mapper[newVal]);
                this.oldTimeLineMode = await this.tab_index_mapper[oldVal]
                this.newTimeLineMode = await this.tab_index_mapper[newVal]
            },
            immediate: true
        },
        displaySameTimeLineHint: {
            handler: function(newVal) {
                console.log(newVal);
                // if (newVal) {
                //     this.selected_tab = 0
                // } else {
                //     this.selected_tab = 1
                // }
            }
        }
    },
    computed: {
        ...mapGetters(["loggedInfo","marketing_card","oldSettingData"]),
        whichStep() {
            console.log(this.step);
            return this.step
        },
        disabledTab() {
            return (index) => this.displaySameTimeLineHint ? ((index === 0 || index === 2) ? true : false) : false;
        },
        tabItems() {
            // return this.displaySameTimeLineHint ? ['活動進行'] : ['活動預熱','活動進行','活動結束']
            // return ['活動預熱','活動進行','活動結束']
            return ['活動預熱','活動進行','活動結束']
        }
    },
    methods: {
        getCard(setting_id, org_id) {
            let result = []
            result = apiGetCard(setting_id, org_id)
                .then(resp => {
                    console.log(resp);
                    // const keys = ['start_at', 'campaign_start_at', 'end_at', 'campaign_end_at'];
                    // keys.forEach( key => {
                    //     if (resp.data.data[key] !== null) {
                    //         if (resp.data.data[key].includes('1970-01-01') ) {
                    //             resp.data.data[key] = ''
                    //         }
                    //     } else {
                    //         resp.data.data[key] = ''
                    //     }

                    // })
                    return resp.data.data
                    // this.$store.commit('old_setting_data', resp.data.data)
                })
                .catch(error => {
                    console.error(error)
                    throw error
                })

            return result    
        },
        goToStep2() {
            this.$utils.scroll_to('normal-setting')
            // if (aaa) {
            //     this.step = "2"
            // }
        },
        handleScroll() {
            if (window.scrollY > 400) {
                this.display = true
            } else if (window.scrollY <= 100) {
                this.step = 1
                this.display = false
            } 
            else {
                this.display = false
            }
        },
        goToTop() {
            console.log(document.documentElement.scrollTop);
            let scrollTo = 0
            goTo(scrollTo)
        },
        updateMiniCardInnerHTML(innerHTML) {
            this.miniCardInnerHTML = innerHTML
        },
        updateDesktopMiniCardInnerHTML(value) {
            this.desktopMiniCardInnerHTML = value
        },
        updateCardInnerHTML(value) {
            // console.log('card_content',value);
            this.cardInnerHTML = value
        },
        loadOldSettingData(arrArg) {
            console.log("!!!!!!!!!!!!!!!!!!!!!!!!!");
            console.log(arrArg);
            console.log(arrArg[0]);
            this.$nextTick(() => {
                this.isLoadOldSettingData = arrArg[0]
            })
        },
        getMarketingCardMode(arrArg) {
            console.log(arrArg);
            let aaa = arrArg[0]
            console.log(typeof aaa === "object");
            console.log(aaa);
            if (typeof aaa === "object") {
                this.marketingCardMode = arrArg[0]['mode']
                // let tmp = JSON.parse(JSON.stringify(aaa['setting']))
                // this.marketingCardModeSetting[aaa['mode']]['card_setting'] = tmp
            } else {
                this.marketingCardMode = arrArg[0]
            }
        },
        getModeCardSetting(arrArg) {
            console.log(arrArg);
            let tmp = JSON.parse(JSON.stringify(this.marketingCardModeSetting[arrArg[0]]['card_setting']))
            this.modeCardSetting = tmp
            console.log(this.modeCardSetting);
        },
        changeStatus: async function(param_name,field_name, new_value){
            this.$nextTick(() => {
                let tmp = JSON.parse(JSON.stringify(this.$store.getters.marketing_card)) 
                tmp[field_name] = new_value
                console.log(field_name)
                console.log(new_value)
                this.$store.commit(param_name, tmp)
                console.log('after_commit', this.$store.getters[param_name])
            })
        },
        getTimeLineMode(arrArg) {
            // alert(arrArg)
            // console.log(arrArg);
            this.time_line_mode = arrArg[0]
        },
        getTimeLine(Arg) {
            console.log(Arg);
            this.timeLine = this.timeLine.map(item => {
                if (item.key === Arg[0]['key']) {
                    return {...item, date: Arg[0]['value'] === null ? "" : Arg[0]['value']}; 
                } else {
                    return item
                }
            })
            console.log("$$$$$$$$$$$$$$$$$$",this.timeLine);
        },
        getStep(arrArg) {
            this.step = arrArg[0]
        },
        async sameTimeLineHint(arrArg) {
            console.log("~~~~~~~~~~~~~~~~~~", arrArg[0]);
            if (arrArg[0]) {
                // alert('時間相同')
                this.displaySameTimeLineHint = arrArg[0]
                this.timeLine[0]['visible'] = false
                this.timeLine[3]['visible'] = false
                this.timeLine[2]['time_line_mode'] = ''
                this.selected_tab = 1
                // this.selected_tab = 0
                // this.marketingCardMode = '活動進行'
            } else {
                this.displaySameTimeLineHint = await arrArg[0]
                this.timeLine[0]['visible'] = await true
                this.timeLine[3]['visible'] = await true
                this.timeLine[2]['time_line_mode'] = await '活動結束'
                // this.marketingCardMode = await '活動進行'
                // this.selected_tab = await 1
            }
        },
        save(){
            let that = this
            console.log('save',this.saveMarketingCard)
            this.saveMarketingCard = false
            console.log('save',this.saveMarketingCard)
            setTimeout(function(){
                that.saveMarketingCard = true
            },200)
        },
        async delSetting(){
            let is_del = confirm('你確定要刪除這張圖卡？')
            console.log(is_del)
            if (!is_del) {
                return
            }

            try {
                let result = await apiDeleteCardWithData(
                    this.$route.query.setting_id, this.$route.params.org_id
                )
                console.log(result)
                this.$root.vtoast.show({
                    message: `刪除圖卡成功！`,
                    color: 'primary'
                })
                this.$router.replace({
                    path: `/${this.$route.params.org_id}/${this.$route.params.container_id}/optimize_site/marketing_card/`
                })
            } catch (error) {
                this.$root.vtoast.show({
                    message: `刪除圖卡失敗，原因: ${error}`,
                })
            }
        },
        stopMarketingCard: async function(){
            try {
                let result = await apiDisabledCard(
                    this.$route.params.org_id, this.$route.query.setting_id
                )
                console.log(result)
                this.card_data = await this.getCard(this.$route.query.setting_id, this.$route.params.org_id)
                console.log('card_data', this.card_data)
            } catch (error) {
                this.$root.vtoast.show({
                    message: `結束圖卡失敗，原因: ${error}`,
                })
            }
        },
        releaseMarketingCard: async function(){
            try {
                let result = await apiReleaseCard(
                    this.$route.params.org_id, this.$route.query.setting_id
                )
                console.log(result)
                this.card_data = await this.getCard(this.$route.query.setting_id, this.$route.params.org_id)
                console.log('card_data', this.card_data)
            } catch (error) {
                if (error.includes('interval')) {
                    this.$root.vtoast.show({
                        message: `發布圖卡失敗，原因: ${this.$utils.displayISOString(this.marketing_card.start_at)} ~ ${this.$utils.displayISOString(this.marketing_card.end_at)}，能夠發布的圖卡已達方案上限。`,
                    })
                }
                else {
                    this.$root.vtoast.show({
                        message: `發布圖卡失敗，原因: ${error}`,
                    })
                }

            }
        },
        async reload(){
            try {
                if (this.$route.query.setting_id) {
                    // this.$store.commit('update_marketing_card', { setting_id : this.$route.query.setting_id })
                    this.card_data = await this.getCard(this.$route.query.setting_id, this.$route.params.org_id)
                    console.log('card_data', this.card_data)
                }
                else {
                    this.card_data = JSON.parse(JSON.stringify(this.marketingCardModeSetting[this.newTimeLineMode].card_setting))
                }
                
            } catch (error) {
                console.log('single_error:', error)
                this.$root.vtoast.show({
                    message: `取得圖卡失敗，原因: ${error}`,
                })
                this.$router.go(-1)
            }

            // alert(this.marketing_card)
            console.log("yo Marketing Card Edit");
            console.log(this.marketing_card);
            console.log(this.marketingCardModeSetting);
            let warm = this.marketingCardModeSetting['活動預熱']['card_setting']
            // let activity = this.marketingCardModeSetting['活動進行']['card_setting']
            // let end = this.marketingCardModeSetting['活動結束']['card_setting']
            // console.log(warm);
            // console.log(this.loggedInfo?.['default_value']?.['containersValue']?.[this.selectedContainer?.['name']]);
            // console.log(this.loggedInfo?.['default_value']?.['containersValue']?.[this.selectedContainer?.['name']]?.['preview_url']);
            // if (warm) {
            //     warm['preview_url'] = this.loggedInfo?.['default_value']?.['containersValue']?.[this.selectedContainer?.['name']]?.['preview_url'] || "";
            // }
            this.$store.commit('update_warm_up_card_setting', warm)
            this.$store.commit('update_activity_card_setting', this.marketingCardModeSetting['活動進行']['card_setting'])
            this.$store.commit('update_end_up_card_setting', this.marketingCardModeSetting['活動結束']['card_setting'])

            // 強迫顯示要取代的麵包屑
            this.$store.commit('update_breadcrumbs',[
                {
                    "text": "站台優化",
                    disabled: true,
                },
                {
                    "text": "行銷圖卡",
                    "href":  `/${this.$route.params.org_id}/${this.$route.params.container_id}/optimize_site/marketing_card/`,
                    disabled: false,
                },
                {
                    "text": this.card_data !== null ? this.card_data.setting_name : "新增圖卡設定檔",
                }
            ])
            this.is_loaded = true
            this.mk_key += 1
        }
    },
    mounted() {
        // 確保瀏覽器繪製完成才去做這個動作，避免畫面閃一下
        // this.$nextTick( () => {
        //     this.step = 1
        //     // 取使用者設定好的預設圖片連結
        //     let img_src = this.loggedInfo?.['default_value']?.['containersValue']?.[this.selectedContainer?.['name']]?.['card_image'] || ""
        //     img_src !== "" && this.changeStatus('marketing_card','img_url', img_src)

        // })
        this.scrollHandler = () => this.handleScroll();
        window.addEventListener('scroll', this.scrollHandler);
    },
    destroyed: function() {
        this.displaySameTimeLineHint = false
        let param = {
            get_ele_innerHTML: false,
            mini_card_ele:"",
            card_content:"",
            desktop_card_hint: "",
            mobile_card_margin: "",
            mobile_card_padding: "",
            mobile_mini_card_margin: "",
            mobile_mini_card_padding: "",
            desktop_card_margin: "",
            add_column: "",
            container_id: "",

            /* tinymce輸入內容的變數 */
            tinymce_content: '<p>圖卡內文</p>',

            /* tinymce初始設定檔 */
            init: {
                selector: '#tinymce',
                language_url: '/tinymce/langs/zh_TW.js',
                language: 'zh_TW', 
                skin_url: '/tinymce/skins/ui/oxide',
                height: "200px",
                branding: false,
                menubar: false,
                plugins: 'link',
                toolbar:'undo redo| fontsizeselect | forecolor |  bold italic underline | link',
                content_style: "p { margin:0px;padding:0px; line-height: 1.3;}",			
                },

                /* 圖卡設定檔名稱 */
                setting_name: '',

                /* 圖卡預覽網址 */
                preview_url: '',

                /* 圖卡作用網域 */
                activate_domain: '',

                /* 圖卡作用優惠代碼 */
                activate_coupon: '',

                /* 開始時間 */
                start_at: '',

                /* 結束時間 */
                end_at: '',

                /* 是否自動帶入優惠代碼 */
                isAutoCoupon: false,

                /* 圖卡叉叉顏色 */
                card_close_color: '#000',

                /* 手機原始圖卡向下位移 */
                card_mobile_mg_top:'50',

                /* 手機縮小圖卡向下位移 */
                card_mobile_mini_mg_top: '50',

                /* 桌機原始圖卡向上位移 */
                card_desktop_mg_bottom: '10',

                /* 桌機原始圖卡向左位移 */
                card_desktop_mg_right: '10',

                /* 原始圖卡圖片 */
                card_img_src: 'https://pic.optimize99.com/api/img/_/cmp/1690251392463.jpg',

                /* 原始圖卡圖片背景顏色 */
                card_img_bg_color: '',

                /* 原始圖卡標題設定 */
                card_title: '圖卡標題',
                card_title_color: '#000',
                card_title_bg_color: '#ffffff',
                card_title_align: 'left',

                /* 原始圖卡行銷文字設定 */
                card_hint:'行銷文字',
                card_hint_color: '#000',
                card_hint_bg_color: '#ffffff',
                card_hint_align:'center',

                /* 原始圖卡內文設定 */
                card_content_bg_color: '#ffffff',

                /* 桌機縮小圖卡設定 */
                desktop_mini_card_text: '桌機縮小的行銷文字',
                desktop_mini_card_color:'#ffffff',
                desktop_mini_card_bg_color:'#ffb3be',
                desktop_mini_card_align: 'center',
                desktop_mini_card_opacity: '',      	

                /* 手機縮小圖卡設定 */
                mini_card_text: '手機縮小的行銷文字',
                mini_card_color:'#ffffff',
                mini_card_bg_color:'#ffb3be',
                mini_card_align: 'center',
                mini_card_opacity: '',

                /* 設定檔資料庫id */
                setting_id: '',

                /* activate_domain 和 activate_coupon 檢查錯誤訊息 */
                message: '',

                /* 手機原始圖卡檢查錯誤訊息 */
                origin_card_message: '',

                /* 手機縮小圖卡檢查錯誤訊息 */
                mini_card_message:'',

                /* 桌機原始圖卡檢查錯誤訊息 */
                desktop_card_bottom_message: '',
                desktop_card_right_message: '',

                /* 倒數計時說明文字 */
                count_down_text: "限時倒數",
                count_down_text_bg_color: "#ffb3be",
                count_down_text_color: "#ff0f0f",

                //結尾
                count_down_text_end: "！",
                count_down_text_end_color: "#ff0f0f",

                count_down_d_text: "日",
                count_down_d_text_color: "#FFF",
                count_down_d_value_color: "#FFF",

                count_down_h_text: "小時",
                count_down_h_text_color: "#FFF",
                count_down_h_value_color: "#FFF",

                count_down_m_text: "分",
                count_down_m_text_color: "#FFF",
                count_down_m_value_color: "#FFF",

                count_down_s_text: "秒",
                count_down_s_text_color: "#FFF",
                count_down_s_value_color: "#FFF",

                /*  */
                mobile_mini_card_count_down_text: "▼",
                mobile_mini_card_count_down_text_color: "#000",
                mobile_mini_card_count_down_text_end: "▼",
                mobile_mini_card_count_down_text_end_color: "#000",      	
                desktop_mini_card_count_down_text: "▶",
                desktop_mini_card_count_down_text_color: "#000",
                desktop_mini_card_count_down_text_end: "▶",
                desktop_mini_card_count_down_text_end_color: "#000",
            
            // 重複輪迴日
            repeat_day: 0,
            
            
            editedCity:[],
            generalMarketingCard: false,
            cityMarketingCard: false,
            cityname:"",
            districtname:"",

            // 提示使用者之訊息
            return_msg:'請先選擇縣市再選擇行政區~',

            // 縣市或一般行銷圖卡的選擇，單選按鈕選定的值
            row: '',

            /* 設定檔圖卡tags */
            setting_tags: '',

            /* copy_mode = "on" */
            copy_setting_tags: '',

            // 倒數計時結束後要顯示的文字內容
            timer_off_text: '活動已結束',

            // 倒數計時結束後要顯示的文字顏色
            timer_off_text_color: "#ff0f0f",
            
            // 商品優惠價格字體大小
            discount_price_size: "",

            // 商品優惠價格
            discount_price: "NT$",

            // 商品優惠價格顏色
            discount_price_color: "#ff0f0f",
            
            // 商品文字字體大小
            product_text_size: "",

            // 商品文字
            product_text: "",

            // 商品文字顏色
            product_text_color: "#ff0f0f",

            // 商品價格模式選擇
            product_mode: 0,

            // 活動開始時間
            campaign_start_at: "",

            // 活動結束時間
            campaign_end_at: "",

            // 圖片網址
            img_url: ''
        }

        //變回初始狀態
        this.$store.commit('marketing_card', param)
        
        // 移除瀏覽器監聽滾動事件
        window.removeEventListener('scroll', this.scrollHandler);
    }
	
}
</script>

<style scoped>

    #time-line div.p-timeline-event-separator div.p-timeline-event-connector {
        background-color: red !important;
    }

    .container {
        display: flex;
        flex-direction: column;
        height: 100%;
        max-width: 100% !important;
    }

    .preview-container, .setting-container {
        display: flex;
        flex-direction: column;
    }

    .preview-container {
        /* width: 60%; */
        max-width: 480px;
        margin-right: 1em;
        height: 100%;
    }

    .campaign-tab {
        border: 1px #CCC solid;
        position: sticky;
        top: -12px;
        z-index: 1;
    }

    .truncate{
        max-width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: block !important;
        /* margin-right: auto; */
        box-sizing: border-box;
    }

    #create .v-speed-dial {
        position: absolute;
    }

    #create .v-btn--floating {
        position: relative;
    }

    .fade-enter-active, .fade-leave-active {
        transition: transform 0.3s;
    }

    .fade-enter, .fade-leave-to {
        transform: scale(0);
    }

    .step-1-style-stepper{
        position: sticky;
        z-index: 5;
        top: 135px;
    }

    .step-1-style-card-action{
        position: sticky;
        z-index: 5;
        top: 65px;
    }

    .step-other-style-stepper{
        position: sticky;
        z-index: 5;
        top: 135px;
    }

    .step-other-style-card-action{
        position: sticky;
        z-index: 4;
        top: 65px;
    }

</style>